<template>
    <div class="small">
        <line-chart :options="{maintainAspectRatio: false}"
                    :styles="{height: '400px',width: '100%',position: 'relative'}"
                    :chart-data="data">
        </line-chart>
    </div>
</template>

<script>
  import LineChart from './line-chart'
  import moment from 'moment';

  export default {
    props: {
      collection: Array
    },
    components: {
      LineChart
    },
    data() {
      return {
        data: {}
      }
    },
    computed: {
      labels() {
        return this.collection.map((item) => {
          return moment().year(item.year).month(item.month).format('MMM-YYYY');
        })
      }
    },

    methods: {
      fillData() {
        this.data = {
          labels: this.labels,
          datasets: [
            {
              label: 'Appointment Trends',
              borderColor: '#303a42',
              pointBackgroundColor: '#303a42',
              borderWidth: 1,
              pointBorderColor: '#303a42',
              data: this.collection.map((item) => item.total)
            }
          ]
        }
      }
    },
    watch: {
      'collection': function () {
        this.fillData()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Charts/LineChart.vue